import React, {Component} from 'react';
import Header from './Header.js';
import Video from './HeaderMedia.js';
import TrimmisHeader from './TrimmisHeader.js';
import ListOfProductsBlue from './ListOfProductsBlue.js';
import InfoCardBlue from './InfoCardBlue.js';
import StoresOnMapViewer from './StoresOnMapViewer';
import FacebookPageEmbed from './FacebookPage.js';
import ArticleBanner from './ArticleBanner.js';
import PriceCalculator from './PriceCalculator.js';
import ImageLink from './ImageLink.js';
import DigitalBookerApiClient from '../utils/digital-booker-api-client';
import NewsLetter from './NewsLetter.js';

import placeholder1 from '../img/placeholder-1.jpg';
import placeholder2 from '../img/placeholder-2.jpg';
import placeholder3 from '../img/placeholder-3.jpg';
import Block_3 from '../img/Block_3.png';
import trimmisRekryImage from '../img/Trimmausasema-490x300.jpg';
import trimmisSmallDogBannerImage from '../img/Pienen-koiran-490x300.jpg';


class TrimmisFrontpage extends Component {

    render() {
          const videos = [
            "https://res.cloudinary.com/mustijamirri/video/upload/v1491994716/trimmis_landing_page_video_01_c8dre0.mp4?vid=1",
            "https://res.cloudinary.com/mustijamirri/video/upload/v1491994716/trimmis_landing_page_video_01_c8dre0.mp4?vid=2",
            "https://res.cloudinary.com/mustijamirri/video/upload/v1491994716/trimmis_landing_page_video_01_c8dre0.mp4?vid=3"
          ];

          const mobileGif = "http://i.imgur.com/AKGhGUX.gif";

        return (
            <div>
                <Header />
                <Video
                    src={videos}
                    mobileGif={mobileGif}
                    type="video/mp4"/>
                <div className='container trimmis-main-container'>
                    <TrimmisHeader fixedClass="trimmis-fixed-logo animated fadeInDown" normalClass="trimmis-logo" marginTopForFixed={200}/>
                    <div className="row content-margin-20">
                        <div className="col-md-4 col-sm-12 mabile-top-margin-20">
                            <ImageLink imgUrl={placeholder1} height="300px" text='Nyppimiskäsittelyt' link="#"
                                       linkText="Näytä lisää" buttonWidth="50%" gridWidth="4"/>
                        </div>
                        <div className="col-md-4 col-sm-12 mabile-top-margin-20">
                            <ImageLink imgUrl={placeholder2} height="300px" text='Pentujen trimmaus ja totuttaminen'
                                       link="#" linkText="Näytä lisää" buttonWidth="50%" gridWidth="4"/>
                        </div>
                        <div className="col-md-4 col-sm-12 mabile-top-margin-20">
                            <ImageLink imgUrl={placeholder3} height="300px" text='Kynsien leikkaus ja tassuhoidot'
                                       link="#" linkText="Näytä lisää" buttonWidth="50%" gridWidth="4"/>
                        </div>
                    </div>
                    <div className="row equal-height-row">
                        <div className="col-md-9 col-sm-12">
                            <StoresOnMapViewer title="Find your Trimmis"
                                               dataLoader={new DigitalBookerApiClient('trimmisfi', 'fi')}/>
                        </div>
                        <div className="col-md-3 col-sm-12 mabile-top-margin-20">
                            <InfoCardBlue title="Suosittelen lämpimästi! Mahtava kokemus!"
                                          description="Mahtava palvelu ja helppo ajanvaraus" buttonText="Näytä lisää"
                                          descriptionOwner="Koiran omistaja"/>
                        </div>
                    </div>
                    <div className="row equal-height-row">
                        <div className="col-md-9 col-sm-12 content-margin-20">
                            <ImageLink imgUrl={Block_3} height="300px"
                                       text='Suuren koiran trimmaus ja hoito-ohjeet kotihoidon tueksi' link="#"
                                       linkText="Näytä lisää"/>
                            <ArticleBanner
                                title="Onko sinulla visio ensiluokkaisesta trimmausasemasta ?"
                                image={trimmisRekryImage}
                                link="#" imageAligned="right" color="#93CEBC"/>
                            <ArticleBanner
                                title="Pienen koiran trimmaus ja hoito-ohjeet kotihoidon tueksi"
                                image={trimmisSmallDogBannerImage}
                                link="#" imageAligned="left" color="#25408F"/>
                        </div>
                        <div className="col-sm-3">
                            <FacebookPageEmbed pageUrl="https://www.facebook.com/trimmissuomi/" name="Trimmis Suomi"/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-9">

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-9 col-sm-12">
                            <NewsLetter title="Newsletter"
                                        text="Subscribe to our email newsletter for useful tips and valuable resources"/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-9 col-sm-12">
                            <PriceCalculator />
                        </div>
                    </div>
                    <div className="row content-margin-20">
                        <div className="col-md-9 col-sm-12">
                            <ListOfProductsBlue title="Services"/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default TrimmisFrontpage;


// WEBPACK FOOTER //
// ../components/TrimmisFrontpage.js